export function getDisplayQuestions(questions, formData) {
  var display_questions = [];
  var st_questions = [];
  if (questions && formData) {
    for (var i = 0; i < questions.length; i++) {
      if (questions[i].optionId == null) {
        display_questions.push(questions[i].id);
        if (questions[i].type == "ST") {
          st_questions.push(questions[i].id);
        }
      }
    }
  }
  while (st_questions.length != 0) {
    var current_question = st_questions.pop();
    if (formData[current_question] != null) {
      for (var i = 0; i < questions.length; i++) {
        if (questions[i].optionId == formData[current_question]) {
          display_questions.push(questions[i].id);
          if (questions[i].type == "ST") {
            st_questions.push(questions[i].id);
          }
        }
      }
    }
  }
  return display_questions;
}
